import { useSelector } from 'react-redux';

import { selectUserToken } from '../redux/features/user/userSelectors';
import { useGetPdfLinkMutation } from '../redux/services/realties/realtiesApi';
import { apiUrl } from '../redux/services/api';
import { handleResponseError } from '../utils/data';
import { showError } from '../utils/ui';
import { openInNewTab } from '../utils/openInNewTab';

// Realty fiche / poster / archive: the backend signs a short-lived link, printed
// with the agent's own contact (details 'self') or none ('none').
export function useOpenPdf() {
  const userToken = useSelector(selectUserToken);
  const [getPdfLink] = useGetPdfLinkMutation();

  return body =>
    openInNewTab(
      async () =>
        `${apiUrl}${(await getPdfLink({ token: userToken, ...body }).unwrap()).url}`,
      error => showError(handleResponseError(error))
    );
}
